import { createAction, createReducer } from "@reduxjs/toolkit"
import { api } from "./helpers/api"

import { LOADING_INITIAL_STATE, setFailed, setReceived, setRequested } from "modules/loader-watchers/helpers/loading"

// Actions
const connectPayPalRequested = createAction("payment-provider/connectPayPalRequested")
const connectPayPalReceived = createAction("payment-provider/connectPayPalReceived")
const connectPayPalFailed = createAction("payment-provider/connectPayPalFailed")

// PayPal Orders
const createPayPalOrderRequested = createAction("payment-provider/createPayPalOrderRequested")
const createPayPalOrderReceived = createAction("payment-provider/createPayPalOrderReceived")
const createPayPalOrderFailed = createAction("payment-provider/createPayPalOrderFailed")

const capturePayPalOrderRequested = createAction("payment-provider/capturePayPalOrderRequested")
const capturePayPalOrderReceived = createAction("payment-provider/capturePayPalOrderReceived")
const capturePayPalOrderFailed = createAction("payment-provider/capturePayPalOrderFailed")

const disconnectPayPalRequested = createAction("payment-provider/disconnectPayPalRequested")
const disconnectPayPalReceived = createAction("payment-provider/disconnectPayPalReceived")
const disconnectPayPalFailed = createAction("payment-provider/disconnectPayPalFailed")

// Reducer
const initialState = {
  ...LOADING_INITIAL_STATE,
  connectPayPal: {
    ...LOADING_INITIAL_STATE
  },
  createPayPalOrder: {
    ...LOADING_INITIAL_STATE
  },
  capturePayPalOrder: {
    ...LOADING_INITIAL_STATE
  },
  disconnectPayPal: {
    ...LOADING_INITIAL_STATE
  }
}

const paymentProviderReducer = createReducer(initialState, {
  [connectPayPalRequested.type]: (state) => {
    setRequested(state.connectPayPal)
  },
  [connectPayPalReceived.type]: (state) => {
    setReceived(state.connectPayPal)
  },
  [connectPayPalFailed.type]: (state) => {
    setFailed(state.connectPayPal)
  },
  // Create Order
  [createPayPalOrderRequested.type]: (state) => {
    setRequested(state.createPayPalOrder)
  },
  [createPayPalOrderReceived.type]: (state) => {
    setReceived(state.createPayPalOrder)
  },
  [createPayPalOrderFailed.type]: (state) => {
    setFailed(state.createPayPalOrder)
  },
  // Capture Order
  [capturePayPalOrderRequested.type]: (state) => {
    setRequested(state.capturePayPalOrder)
  },
  [capturePayPalOrderReceived.type]: (state) => {
    setReceived(state.capturePayPalOrder)
  },
  [capturePayPalOrderFailed.type]: (state) => {
    setFailed(state.capturePayPalOrder)
  },
  // Disconnect PayPal
  [disconnectPayPalRequested.type]: (state) => {
    setRequested(state.disconnectPayPal)
  },
  [disconnectPayPalReceived.type]: (state) => {
    setReceived(state.disconnectPayPal)
  },
  [disconnectPayPalFailed.type]: (state) => {
    setFailed(state.disconnectPayPal)
  }
})

export default paymentProviderReducer

export const connectPayPal = (source) =>
  api({
    url: "/guide/paypal_accounts/start_onboarding",
    method: "post",
    data: { source },
    onStart: connectPayPalRequested.type,
    onSuccess: connectPayPalReceived.type,
    onError: connectPayPalFailed.type
  })

export const disconnectPayPal = () =>
  api({
    url: "/guide/paypal_accounts/disconnect",
    method: "put",
    onStart: disconnectPayPalRequested.type,
    onSuccess: disconnectPayPalReceived.type,
    onError: disconnectPayPalFailed.type
  })

// Create PayPal Order
export const createPayPalOrder = (data) =>
  api({
    url: "/paypal/create_order",
    method: "post",
    data,
    onStart: createPayPalOrderRequested.type,
    onSuccess: createPayPalOrderReceived.type,
    onError: createPayPalOrderFailed.type
  })

// Capture PayPal Order
export const capturePayPalOrder = (data) =>
  api({
    url: `/paypal/capture_order`,
    method: "post",
    data,
    onStart: capturePayPalOrderRequested.type,
    onSuccess: capturePayPalOrderReceived.type,
    onError: capturePayPalOrderFailed.type
  })
